export class IStorageStrategy {
}
//# sourceMappingURL=IStorageStrategy.js.map